import { render, staticRenderFns } from "./IncidentsAndComplaints.vue?vue&type=template&id=35771448&"
import script from "./IncidentsAndComplaints.vue?vue&type=script&lang=js&"
export * from "./IncidentsAndComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports